import { render, staticRenderFns } from "./LetterComponent.vue?vue&type=template&id=47d7322e&scoped=true"
import script from "./LetterComponent.vue?vue&type=script&lang=js"
export * from "./LetterComponent.vue?vue&type=script&lang=js"
import style0 from "./LetterComponent.vue?vue&type=style&index=0&id=47d7322e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d7322e",
  null
  
)

export default component.exports